var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Frogger',{key:_vm.uid,attrs:{"controller":_vm.controller,"tickerController":_vm.tickerController,"boardSettingSeed":_vm.seed},on:{"tick":_vm.onTick,"gameStatus":_vm.onGameStatus}})}
var staticRenderFns = []

export { render, staticRenderFns }